import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
const PendingOrders = (params) => {
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />
        <div className="inner-content">
          <div className="container px-0">
            <div className="row">
              <div className="accordion" id="accordionPanelsStayOpenExample">
                <div className="accordion-item">
                  <h2
                    className="accordion-header"
                    id="panelsStayOpen-headingNine2"
                  >
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#panelsStayOpen-collapseNine2"
                      aria-expanded="true"
                      aria-controls="panelsStayOpen-collapseNine2"
                    >
                      <div className="col d-flex align-items-center justify-content-between">
                        <h4 className="event-alert p-0 mb-0">
                          Orders Pending Receipt
                        </h4>
                      </div>
                    </button>
                  </h2>
                  <div
                    id="panelsStayOpen-collapseNine2"
                    className="accordion-collapse collapse show"
                    aria-labelledby="panelsStayOpen-headingNine2"
                  >
                    <div className="row mx-0">
                      <div className="container px-0">
                        <div className="shadowclass mt-0">
                          <div className="col-md-4">
                            <div className="search-box mt-0">
                              <form type="GET">
                                <input
                                  type="text"
                                  placeholder="Search"
                                  name="keyword1"
                                />
                                <input type="submit" />
                              </form>
                            </div>
                          </div>
                          <div className="table-responsive general-setting saved_order_ms">
                            <div className="orderList">
                              <table className="checklist-table remove-space ingredTable">
                                <thead>
                                  <tr>
                                    <th>ID</th>
                                    <th>PO #</th>
                                    <th>Payee</th>
                                    <th>Sub Total</th>
                                    <th>Order Discount</th>
                                    <th>Item Discount</th>
                                    <th>Sales Tax</th>
                                    <th>Final Cost</th>
                                    <th>Sent</th>
                                    <th>Requested Delivery Date</th>
                                    <th>Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr className="order_row">
                                    <td>OR000002</td>
                                    <td>0000000067</td>

                                    <td className="payeeTd">
                                      <b>Marketing Payee</b>
                                      <br />
                                      ID INv2
                                    </td>
                                    <td className="align-right">$2,500.00</td>
                                    <td className="align-right">($0.00)</td>
                                    <td className="align-right">($0.00)</td>
                                    <td className="align-right">$125.00</td>
                                    <td className="align-right">$2,625.00</td>
                                    <td>Nov 29,2021</td>
                                    <td>Oct 02,2021</td>
                                    <td className="d-td-wd">
                                      <div className="discount-btns right-btns-sec">
                                        <a
                                          href="/orders/edit/67"
                                          className="circle_icon edit_tooltip"
                                        >
                                          <i className="iconSprites edit-icon"></i>
                                        </a>
                                        <div className="uploadtd">
                                          <div className="uploadcover">
                                            <div className="circle_icon">
                                              <button className="iconSprites upload-icon uploadInv">
                                                <div className="tooltip-sm">
                                                  Upload Invoice
                                                </div>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <a
                                          className="circle_icon red cancel_order"
                                          title="Cancel Order"
                                        >
                                          <i className="iconSprites cancel-icon"></i>
                                        </a>
                                        <button
                                          className="btn bordered-btn discount mx-2 align-self-center"
                                          val="67"
                                        >
                                          $ Discount
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr className="order_row">
                                    <td>OR000002</td>
                                    <td>0000000067</td>

                                    <td className="payeeTd">
                                      <b>Marketing Payee</b>
                                      <br />
                                      ID INv2
                                    </td>
                                    <td className="align-right">$2,500.00</td>
                                    <td className="align-right">($0.00)</td>
                                    <td className="align-right">($0.00)</td>
                                    <td className="align-right">$125.00</td>
                                    <td className="align-right">$2,625.00</td>
                                    <td>Nov 29,2021</td>
                                    <td>Oct 02,2021</td>
                                    <td className="d-td-wd">
                                      <div className="discount-btns right-btns-sec">
                                        <a
                                          href="/orders/edit/67"
                                          className="circle_icon edit_tooltip"
                                        >
                                          <i className="iconSprites edit-icon"></i>
                                        </a>
                                        <div className="uploadtd">
                                          <div className="uploadcover">
                                            <div className="circle_icon">
                                              <button className="iconSprites upload-icon uploadInv">
                                                <div className="tooltip-sm">
                                                  Upload Invoice
                                                </div>
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                        <a
                                          className="circle_icon red cancel_order"
                                          title="Cancel Order"
                                        >
                                          <i className="iconSprites cancel-icon"></i>
                                        </a>
                                        <button
                                          className="btn bordered-btn discount mx-2 align-self-center"
                                          val="67"
                                        >
                                          $ Discount
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default PendingOrders;
